import get from "lodash/get";
import {
  FIRST_NAME,
  LAST_NAME,
  COMPANY_NAME,
  PHONE,
  ADDRESS2,
  CITY,
  STATE_NAME_NON_US,
  STATE_NAME,
  ZIPCODE_NON_US,
  ZIPCODE,
  ADDRESS1,
} from "constants/form";

export const createAddressRequestParams = (formValues) => {
  let params = formValues;
  params.phone = params.phone?.replaceAll(" ", "");

  if (params.validationData) {
    const { validationData } = params;
    params.recordType = get(validationData, "lookups.0.result.0.metadata.recordType", null);
  }

  return params;
};

export const formatCountryForAddress = (country) => {
  const { id, iso, dialCode, name, international } = country || {};
  return {
    countryId: id,
    countryIso: iso,
    countryDialCode: dialCode,
    countryName: name,
    isInternational: international,
    ...country,
  };
};

export const initializeFormValues = (address, isInternational) => {
  const hasAddress = (key) => !!address?.[key];
  const formFieldValue = (key) => ({ value: hasAddress(key) ? address[key] : "" });
  const defaultFormFieldValidates = { presence: true };

  const formValues = {
    firstname: {
      ...formFieldValue(FIRST_NAME.name),
      validates: { ...defaultFormFieldValidates, length: { max: 100 } },
    },
    lastname: {
      ...formFieldValue(LAST_NAME.name),
      validates: { ...defaultFormFieldValidates, length: { max: 100 } },
    },
    businessName: {
      ...formFieldValue(COMPANY_NAME.name),
      validates: { presence: false },
    },
    address1: {
      ...formFieldValue(ADDRESS1.name),
    },
    formattedAddress: {
      ...formFieldValue(ADDRESS1.name),
      validates: { ...defaultFormFieldValidates, length: { max: 150 } },
    },
    address2: {
      ...formFieldValue(ADDRESS2.name),
      validates: { ...defaultFormFieldValidates, presence: false, length: { max: 100 } },
    },
    city: {
      ...formFieldValue(CITY.name),
      validates: { ...defaultFormFieldValidates, length: { max: 100 } },
    },
    stateNameNonUs: {
      ...formFieldValue(STATE_NAME_NON_US.name),
      validates: { ...defaultFormFieldValidates, presence: isInternational, length: { max: 100 } },
    },
    stateName: {
      ...formFieldValue(STATE_NAME.name),
      validates: { ...defaultFormFieldValidates, presence: !isInternational, length: { max: 50 } },
    },
    zipcodeNonUs: {
      ...formFieldValue(ZIPCODE_NON_US.name),
      validates: { presence: isInternational },
    },
    zipcode: { ...formFieldValue(ZIPCODE.name), validates: { presence: !isInternational } },
    phone: { ...formFieldValue(PHONE.name), validates: defaultFormFieldValidates },
  };
  return formValues;
};
